// extracted by mini-css-extract-plugin
module.exports = {"artworkWrap":"artist-module--artworkWrap--3KHCL","art":"artist-module--art--1eDMX","artwork":"artist-module--artwork--3kYkN","socialText":"artist-module--socialText--U6hls"};